/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
  if($(window).width() < 641){
    var w = $(window).width();
    $(".ImageHero__Video-Mobile, .ImageHero__Video-Mobile .ImageHero__Video-Player").css("min-height", w/4*5);
  }
  
  setTimeout(function(){
    $(".freegift").appendTo("#freegift");
  }, 1000);
});

$(document).ready(function(){
  $("#add_carts").click(function(){
    $(".firsts").addClass("active");
    $(".seconds").removeClass("active");
    $(".thirds").removeClass("active");
  // window.location.href = window.location.origin + "/cart/?Giftwrap";

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js', 
      data: {
            quantity: 1,
            id: 31858009899143
        }, 
      dataType: 'json',
      success: function() { 
        jQuery.post('/cart/update.js', {updates: {31858009899143: 1, 32196964417671: 0, 32197935726727: 0}});
        window.location.href = window.location.origin + "/cart/?Giftwrap";
      }
    });   
    //jQuery.post('/cart/update.js', {updates: {31858009899143: 1, 32196964417671: 0, 32197935726727: 0}});
  });

  $("#add_signature").click(function(){
     $(".firsts").removeClass("active");
     $(".seconds").addClass("active");
    $(".thirds").removeClass("active");


        jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: 32196964417671
        },
        dataType: 'json',           
        success: function() {
          jQuery.post('/cart/update.js', {updates: {32196964417671: 1, 31858009899143: 0, 32197935726727: 0}});
          window.location.href = window.location.origin + "/cart/?signature";
        }
     });  
    //jQuery.post('/cart/update.js', {updates: {32196964417671: 1, 31858009899143: 0, 32197935726727: 0}});

  });


// $("input#second").click(function () {
//      if ($(this).is(":checked")) {
//          $(".second-check").addClass("active");
//          $(".disablecheck").addClass("disabledbutton");
//        $(".first-check").removeClass("active");
//        $(".wrap-check").removeClass("active");
//        $(".disablecheck"). prop("checked", false);
//         window.location.href = window.location.origin + "/cart/?eco";
//      }});
  $("#add_eco").click(function(){
       $(".thirds").addClass("active");
         $(".seconds").removeClass("active");
         $(".firsts").removeClass("active");
     jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: 32197935726727
        },
        dataType: 'json',           
        success: function() {
           jQuery.post('/cart/update.js', {updates: {32197935726727: 1, 31858009899143: 0, 32196964417671: 0}});
           window.location.href = window.location.origin + "/cart/?eco";
        }
     });  
    //jQuery.post('/cart/update.js', {updates: {32197935726727: 1, 31858009899143: 0, 32196964417671: 0}});
  });

  if (window.location.href.indexOf("?signature") > -1) {
     $(".seconds").addClass("active");
     $(".thirds").removeClass("active");
     $(".firsts").removeClass("active");
  }
  if (window.location.href.indexOf("?eco") > -1) {
       $(".thirds").addClass("active");
     $(".seconds").removeClass("active");
    $(".firsts").removeClass("active");
  }
  if (window.location.href.indexOf("?Giftwrap") > -1) {
    $(".firsts").addClass("active");
    $(".thirds").removeClass("active");
    $(".seconds").removeClass("active");
  }

  setTimeout(function(){      
    $('.placeholder-image').fadeOut();
  }, 1000);

});

function add_carts(){
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js', 
      data: {
            quantity: 1,
            id: 31858009899143
        }, 
      dataType: 'json',
      success: function() { 
        jQuery.post('/cart/update.js', {updates: {31858009899143: 1, 32196964417671: 0, 32197935726727: 0}});
        window.location.href = window.location.origin + "/cart/?Giftwrap";
      }
    }); 
}

function add_signature(){
	jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: 32196964417671
        },
        dataType: 'json',           
        success: function() {
          jQuery.post('/cart/update.js', {updates: {32196964417671: 1, 31858009899143: 0, 32197935726727: 0}});
          window.location.href = window.location.origin + "/cart/?signature";
        }
     });  
}

function add_eco(){
	jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: 32197935726727
        },
        dataType: 'json',           
        success: function() {
           jQuery.post('/cart/update.js', {updates: {32197935726727: 1, 31858009899143: 0, 32196964417671: 0}});
           window.location.href = window.location.origin + "/cart/?eco";
        }
     });  
}